import {createCompositionApi} from '@/shared/api/index.js';

export const EXPORT_REQUEST = 'EXPORT_REQUEST';
export const EXPORT_SUCCESS = 'EXPORT_SUCCESS';
export const EXPORT_FAILURE = 'EXPORT_FAILURE';

// Error codes the reducer stores so the component can pick the right localized message.
export const EXPORT_ERROR_NOT_FOUND = 'notFound';
export const EXPORT_ERROR_FAILED = 'failed';

/**
 * Send the browser directly to the pre-authenticated blob-storage download URL.
 * A transient anchor is used so we never navigate away from the current page.
 * The blob already returns `Content-Disposition: attachment`, so this triggers a
 * real file download. The bytes are never fetched into JS (that would defeat the
 * direct-download design), and the SAS url is never logged.
 */
const triggerDownload = (downloadUrl) => {
    const anchor = document.createElement('a');

    anchor.href = downloadUrl;
    anchor.rel = 'noopener';
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
};

/**
 * Export a catalog item (composition or learning plan) and start the download.
 * Status is tracked per targetId so multiple export buttons stay independent.
 * @param {string} portalIdentifier - The current portal identifier.
 * @param {string} targetId - The catalog item's target id.
 */
export const exportCatalogItem = (portalIdentifier, targetId) => async (dispatch, getState) => {
    dispatch({type: EXPORT_REQUEST, payload: {targetId}});

    try {
        const compositionApi = createCompositionApi(getState().minervaSettings);
        const {downloadUrl} = await compositionApi.exportCatalogItem(targetId, portalIdentifier);

        // Perform the download as a side effect here, after the fetch resolves,
        // before dispatching success. Reducers stay pure.
        triggerDownload(downloadUrl);

        dispatch({type: EXPORT_SUCCESS, payload: {targetId}});
    } catch (error) {
        dispatch({
            type: EXPORT_FAILURE,
            payload: {
                targetId,
                error: error?.status === 404 ? EXPORT_ERROR_NOT_FOUND : EXPORT_ERROR_FAILED,
            },
        });
    }
};
